export default class CardModel {
  Key;
  Index;
  Icon;
  Parameters = [];
}

export class Parameter {
  Key;
  FunctionalFieldlIndex;
  AllowedValues;
  FunctionalSectionKey;
  InputValidationFormat;
  IsRequired;
  Value;
  Traductions;
}
